import { Injectable } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '../components/popup/popup.component';
import { PopupLevel } from '../../shared/enum';
import { IPartner } from '../models/partner';
import { DataService } from './data.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  constructor(private dialog: MatDialog, private dataService: DataService, private translateService: TranslateService, public datepipe: DatePipe) { }

  public openErrorPopup(message: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: 'Fehler',
      message: message,
      level: PopupLevel.Error
    };

    this.dialog.open(PopupComponent, dialogConfig);
  }

  public openWarningPopup(message: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: 'Warnung',
      message: message,
      level: PopupLevel.Warning
    };

    this.dialog.open(PopupComponent, dialogConfig);
  }

  public openInfoPopup(message: string, displayButton: boolean = true, title: string = 'Info') {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: title,
      message: message,
      level: PopupLevel.Info
    };

    const dialogRef = this.dialog.open(PopupComponent, dialogConfig);
    dialogRef.componentInstance.displayButton = displayButton;
  }

  public openOffertAntragInfoPopup(partner: IPartner, anlagedatum: Date, produktName: string) {
    const titlePrefix = partner.TitelPrefix ? this.dataService.getTitelPrefix().get(partner.TitelPrefix) + ' ' : '';
    const titleSuffix = partner.TitelSuffix ? ' ' + this.dataService.getTitelSuffix().get(partner.TitelSuffix) : '';
    const anrede = partner.Anrede === 1 ? 'Sehr geehrte Frau ' + titlePrefix + partner.Nachname + titleSuffix :
      partner.Anrede === 2 ? 'Sehr geehrter Herr ' + titlePrefix + partner.Nachname + titleSuffix :
        partner.Anrede === 3 ? 'Guten Tag, ' + titlePrefix + partner.Vorname + ' ' + partner.Nachname + titleSuffix : 'Guten Tag';

    this.translateService.get('OFFERTANTRAGINFO',
      { anrede: anrede, anlagedatum: this.datepipe.transform(anlagedatum, 'dd.MM.yyyy'), produktName: produktName })
      .subscribe((text: string) => {
        this.openInfoPopup(text);
      });
  }

  public openNewPasscodeSentInfoPopup() {
    this.translateService.get('NEWPASSCODESENTINFO').subscribe((text: string) => {
      this.openInfoPopup(text, false);
    });
  }

  public openEurotaxLeistungElektroInfoPopup(expertMode: boolean) {
    this.translateService.get(expertMode ? 'EUROTAXLEISTUNGELEKTROPRAEMIEEXPERTINFO' : 'EUROTAXLEISTUNGELEKTROPRAEMIEINFO')
      .subscribe((text: string) => {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.restoreFocus = false;

      dialogConfig.data = {
        title: 'Info',
        message: text,
        level: PopupLevel.Info
      };

      const dialogRef = this.dialog.open(PopupComponent, dialogConfig);
      dialogRef.componentInstance.displayButton = true;
    });
  }
}
